import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import './utils/rem';
// import 'lib-flexible'
import 'babel-polyfill';
import pagination from '@/components/common/pagination';

import el_upload from '@/components/common/el_upload';
// import Time from '@/components/common/time';
Vue.config.productionTip = false;
import { put, get, post, del } from '@/utils/request.js';
Vue.component('pagination', pagination);

Vue.component('el_upload', el_upload);


// Vue.component('Time', Time);
Vue.prototype.$put = put;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$del = del;
import {
    dateTime1,
    monthList,
    search_is_active,
    publicAdd,
    formatOrdertime,
    data_detail_status_list,
    client_user_status_list,
    newDate,
    parseParmStr,
    checkPhone,
    user_auth_modules_list,
    order_invoice_type_list,
    order_invoice_status_list,
    accAdd,
    accSub,
    mergeArraysByField,
    arrLIst,
    timestampToTime,
    extra_info,
    formatTimestamp,
    accMul,
    accDiv,
    yearM
} from '@/api/function.js';
Vue.prototype.$accDiv = accDiv;
Vue.prototype.$yearM = yearM;
Vue.prototype.$accMul = accMul;
Vue.prototype.$formatTimestamp = formatTimestamp;
Vue.prototype.$extra_info = extra_info;
Vue.prototype.$timestampToTime = timestampToTime;
Vue.prototype.$mergeArraysByField = mergeArraysByField;
Vue.prototype.$arrLIst = arrLIst;
Vue.prototype.$formatOrdertime = formatOrdertime;
Vue.prototype.$dateTime1 = dateTime1;
Vue.prototype.$data_detail_status_list = data_detail_status_list;
Vue.prototype.$client_user_status_list = client_user_status_list;
Vue.prototype.$newDate = newDate;
Vue.prototype.$parseParmStr = parseParmStr;
Vue.prototype.$checkPhone = checkPhone;
Vue.prototype.$user_auth_modules_list = user_auth_modules_list;
Vue.prototype.$order_invoice_type_list = order_invoice_type_list;
Vue.prototype.$order_invoice_status_list = order_invoice_status_list;
Vue.prototype.$search_is_active = search_is_active;
Vue.prototype.$monthList = monthList;

Vue.prototype.$accAdd = accAdd;
Vue.prototype.$accSub = accSub;
Vue.prototype.$publicAdd = publicAdd;
// 预览图片插件
import hevueImgPreview from 'hevue-img-preview';

Vue.use(hevueImgPreview);

// 引入echarts
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

//
Vue.use(ElementUI, {
    size: 'small'
});
// const i18n = new VueI18n({
//     locale: 'zh',
//     messages
// });
import * as filters from './filters';
// 注册全局过滤器
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});

new Vue({
    store,
    router,
    render: (h) => h(App)
}).$mount('#app');
// i18n,
// this.$message.success('添加成功')

['success', 'warning', 'info', 'error'].forEach(type => {
    ElementUI.Message[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options
            };
            options.duration = 800
            // if (type == 'warning' || type == 'error') {
            //     options.showClose = true
            // }
        }
        options.type = type;
        return ElementUI.Message(options);
    };
});
